// @ts-nocheck



import React, { Component } from 'react';
import { inspectionGibddCalculationApi } from '../../../../lib/api';
import { printNotification } from '../../../../lib/notificationWrapper';
import Common from './components/Common';





export default class extends Component {
  render() {
    const { location, vehiclePlanId } = this.props;
    return (
      <Common
        location={location}
        vehiclePlanId={vehiclePlanId}
        crud={inspectionGibddCalculationApi}
        calcScrollY={400}
        statusField={'inspectionGibddCalculationStatus'}
        title={'Планирование ТО ГИБДД'}
        handlePrint={(filter) => {
          printNotification(async () => {
            await inspectionGibddCalculationApi.print(vehiclePlanId, filter);
          });
        }} />);


  }
}
